import { LoadingOutlined } from "@ant-design/icons";
import { Input, Spin } from "antd";
import { groupBy, sortBy } from "lodash";
import { useMemo } from "react";
import { FaArrowCircleLeft, FaArrowCircleRight } from "react-icons/fa";
import { IoSearchOutline } from "react-icons/io5";
import { useInfoUser } from "../../../store/UserStore";
import { BasicOrgInfo } from "./BasicOrgInfo";
import { useDirectoryContext } from "./DirectoryContext";
import { Organization } from "./Organization";

const CheckedList = () => {
  const { languageMap } = useInfoUser();

  const {
    onDeleteItem,
    orgList,
    isCheckedList,
    setIsCheckedList,
    isCheckedLoading,
  } = useDirectoryContext();

  const memberGroupList = useMemo(() => {
    return sortBy(
      Object.values(
        groupBy(
          orgList?.filter((org) => org?.type === "PERSON" && org?.checked),
          "objectId",
        ),
      ),
      [
        (o) => {
          return o?.[0]?.position;
        },
      ],
    );
  }, [orgList]);
  return (
    <div
      className={
        isCheckedList
          ? "checked-list rounded-md"
          : "non-checked-list rounded-md w-full"
      }
    >
      <div className="p-[12px] flex justify-center gap-[10px] items-center">
        <button
          type="button"
          className="checked-list-icon items-start justify-start"
          onClick={() => setIsCheckedList(false)}
        >
          <FaArrowCircleLeft size={20} />
        </button>
        <div className="font-semibold items-start justify-start w-full border-b text-lg">
          {languageMap?.["modal.organization.checkedList"] ??
            "Selected member list"}{" "}
          <span className="text-[#005ae0] float-right text-[12px]">
            {memberGroupList?.length > 0
              ? memberGroupList?.length +
                  " " +
                  languageMap?.["modal.organization.viewPeoples"] ?? "Checked"
              : ""}
          </span>
        </div>
      </div>
      <div className="relative overflow-y-auto h-[50vh]">
        {memberGroupList?.map((memberGroup) => (
          <BasicOrgInfo
            memberGroup={memberGroup}
            key={memberGroupList[0]?.id}
          />
        ))}
        {isCheckedLoading && (
          <div className="absolute top-[40%] w-full text-center">
            <Spin
              indicator={<LoadingOutlined className="text-[35px]" spin />}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const Directory = ({ isForwardMail, isShowCheckedList = true }) => {
  const { languageMap } = useInfoUser();
  const {
    orgList,
    setOrgList,
    debouncedFilterOrg,
    isCheckedList,
    setIsCheckedList,
    conversationId,
  } = useDirectoryContext();

  return (
    <div className="flex rounded-lg !text-[12px]">
      <div
        className={
          isCheckedList
            ? `non-box-search rounded-md pe-2 mt-0 mr-[12px] ${isForwardMail && "w-full"}`
            : `box-search rounded-md pe-2 mt-0 mr-[12px] ${isForwardMail && "w-full"}`
        }
      >
        <div className="flex items-center mt-2 gap-[10px]">
          <Input
            placeholder={languageMap?.["menu.search.placeholder"] ?? "Search"}
            onChange={(event) => {
              debouncedFilterOrg(event.target.value.trim(), conversationId);
            }}
            prefix={<IoSearchOutline size={15} />}
            allowClear
          />
          <button
            type="button"
            className="checked-list-icon"
            onClick={() => setIsCheckedList(true)}
          >
            <FaArrowCircleRight size={20} />
          </button>
        </div>
        <Organization
          onlyView={false}
          setOrgList={setOrgList}
          orgList={orgList}
          isForwardMail={isForwardMail}
        />
      </div>
      {isShowCheckedList && CheckedList(languageMap)}
    </div>
  );
};

export { Directory };
